@if (theme && hasContent) {
  <div
    class="font-body bg-cover home-hero overflow-hidden {{ theme?.root }}"
    [class.home-hero--video]="videoCta"
    [ngStyle]="heroStyle"
    >
    <div class="container !py-6 lg:!py-0 {{ theme?.container }}">
      <div class="flex lg:items-center {{ theme?.columnOrder }} relative">
        <div class="home-hero__content z-[1] {{ contentWidth }}">
          @if (data.heroTitle && data.heroTitle.length !== 0) {
            <div
              class="pt-v-spacing pb-4 sm:px-v-spacing wysiwyg mx-auto sm:mx-0 w-auto"
              [innerHTML]="data.heroTitle"
            ></div>
          }
          @if (data.showTrustpilot) {
            <div class="pb-4 sm:px-v-spacing">
              <div class="flex flex-wrap content-start gap-[8px]">
                <img
                  class="h-[28px] w-[150px]"
                  height="28"
                  width="150"
                  [alt]="TrustScoreImageAltText"
                  [src]="TrustScoreImageUrl"
                  />
                @if (trustpilotVerified) {
                  <div class="flex items-center text-xs xxsm:text-sm xs:text-base">
                    <span class="mr-2.5"
                      ><span class="font-extrabold">{{ trustpilotTrustScore }}/5</span> Stars</span
                      >
                      <span
                        ><span class="font-extrabold">{{ trustpilotNumberOfReviews | number }}</span> Reviews</span
                        >
                      </div>
                    }
                  </div>
                </div>
              }
              @if (data.heroContent && data.heroContent.length !== 0) {
                <div
                  class="pb-[32px] sm:px-v-spacing home-hero__content wysiwyg mx-auto sm:mx-0 w-auto"
                  [innerHTML]="data.heroContent"
                ></div>
              }
              <div
                [ngClass]="!productPickerContent ? 'sm:grid-cols-2 xl:grid-cols-2' : ''"
                class="pb-v-spacing sm:px-v-spacing grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 list-buttons-container"
                >
                <!-- Product Picker Component -->
                @if (productPickerContent) {
                  <product-picker [data]="productPickerContent"></product-picker>
                }
                <!-- Buttons -->
                @if (!productPickerContent) {
                  @for (b of buttons; track b) {
                    @if (data.buttonListStyle === 'cardButtons') {
                      <div class="w-full button__home_hero z-0">
                        <a
                          class="flex bg-white h-[5.75rem] py-2 px-4 rounded items-center button-shadow hover:bg-pink-100 cursor-pointer"
                          [attr.target]="b.buttonLinkNewTab ? '_blank' : ''"
                [attr.rel]="
                  b.buttonLinkNewTab && b.buttonLinkNofollow
                    ? 'nofollow noopener noreferrer'
                    : b.buttonLinkNewTab && !b.buttonLinkNofollow
                    ? 'noopener noreferrer'
                    : b.buttonLinkNofollow
                    ? 'nofollow'
                    : ''
                "
                          href="{{ b.buttonLink }}"
                          [attr.aria-labelledby]="getIdToAriaLabelledbyContext(b.buttonTitle)"
                          >
                          @if (b.buttonIcon && b.buttonIcon.length > 0) {
                            <img
                              src="{{ b.buttonIcon[0].url }}"
                              width="60"
                              height="60"
                              class="button-icon w-[60px] h-[60px] text-[.5rem]"
                              [alt]="b.buttonIcon[0].altText ? b.buttonIcon[0].altText : ''"
                              />
                          }
                          <div class="items-center w-full ml-3">
                            <h2 class="font-bold text-baselg m-0 text-vis-regular button__home_title leading-[1.688rem]">
                              {{ b.buttonTitle }}
                            </h2>
                            <small class="text-ace-grey-600 button__home_subtitle">{{ b.buttonSubtitle }}</small>
                          </div>
                          <div>
                            <fa-icon
                              class="text-ace-pink-600 fa-1x flex justify-center items-center w-8 h-8"
                              [icon]="faChevronRight"
                              >
                            </fa-icon>
                          </div>
                          <!-- Hidden Context -->
                          <span [attr.id]="getIdToAriaLabelledbyContext(b.buttonTitle)" class="sr-only">{{accessibilityService.getCompleteTextContextForButton(b.buttonLink, b.buttonTitle)}}</span>
                        </a>
                      </div>
                    }
                    <!-- Primary with Arrow Buttons -->
                    @if (data.buttonListStyle !== 'cardButtons') {
                      <a
              [ngClass]="[
                styleButtonsList, 
                data.buttonListStyle !== 'tertiaryButtonsWithArrow' ? '!px-6' : ''
              ]"
                        class="v-button"
                        [attr.target]="b.buttonLinkNewTab ? '_blank' : ''"
              [attr.rel]="
                b.buttonLinkNewTab && b.buttonLinkNofollow
                  ? 'nofollow noopener noreferrer'
                  : b.buttonLinkNewTab && !b.buttonLinkNofollow
                  ? 'noopener noreferrer'
                  : b.buttonLinkNofollow
                  ? 'nofollow'
                  : ''
                "
                        href="{{ b.buttonLink }}"
                        [attr.aria-labelledby]="getIdToAriaLabelledbyContext(b.buttonTitle)"
                        >
                        <span class="md:whitespace-nowrap primary-label mr-auto">{{ b.buttonTitle }}</span>
                        <!-- Hidden Context -->
                        <span [attr.id]="getIdToAriaLabelledbyContext(b.buttonTitle)" class="sr-only">{{accessibilityService.getCompleteTextContextForButton(b.buttonLink, b.buttonTitle)}}</span>
                      </a>
                    }
                  }
                }
              </div>
              <!-- Video CTA (mobile): centered below the buttons. Also the desktop CTA when there is
                   no hero image to overlay it on. -->
              @if (videoCta) {
                <div
                  class="flex justify-center pb-v-spacing"
                  [class.md:hidden]="data.heroImage && data.heroImage.length > 0"
                >
                  <ng-container *ngTemplateOutlet="videoCtaButton"></ng-container>
                </div>
              }
            </div>
            <!-- Video CTA (desktop): hero image with the CTA overlaid on it -->
            @if (videoCta && data.heroImage && data.heroImage.length > 0) {
              <div class="w-1/2 home-hero__image home-hero__image--video hidden md:block relative self-stretch">
                <div class="home-hero__video-media">
                  <!-- Intrinsic size reserves the aspect ratio, so the absolutely positioned box (and the
                       CTA inside it) doesn't move when the image loads. -->
                  <img
                    #heroImg
                    class="w-full h-auto"
                    [attr.width]="data.heroImage[0].width"
                    [attr.height]="data.heroImage[0].height"
                    [src]="heroImageUrl"
                    [alt]="data.heroImage[0].altText ? data.heroImage[0].altText : ''"
                    fetchpriority="high"
                    preloadImg
                    />
                  <ng-container *ngTemplateOutlet="videoCtaButton; context: { $implicit: 'home-hero__video-cta--overlay' }"></ng-container>
                </div>
              </div>
            } @else if (data.heroImage && data.heroImage.length > 0) {
              <div class="w-1/2 home-hero__image hidden md:block">
                <div
          class="home-hero__image-wrapper relative transform -translate-x-[70%] h-[75vh] max-[1440px]:h-[73vh] {{
            imageBleedClass
          }}"
                  style="width: max-content"
                  >
                  <img
                    #heroImg
                    width="670"
                    height="464"
                    class="h-auto w-[670px] lg:w-[770px]"
                    [src]="heroImageUrl"
                    [alt]="data.heroImage[0].altText ? data.heroImage[0].altText : ''"
                    fetchpriority="high"
                    preloadImg
                    />
                </div>
              </div>
            }
          </div>
          @if (data.heroImage && data.heroImage.length > 0 && showImageOnMobile) {
            <div
              class="home-hero__image mx-auto pt-v-spacing md:hidden block"
              >
              <div class="home-hero__image-wrapper">
                <img
                  #heroImg
                  width="268"
                  height="464"
                  class="h-full sm:h-auto w-auto"
                  [src]="heroImageUrl"
                  [alt]="data.heroImage[0].altText ? data.heroImage[0].altText : ''"
                  fetchpriority="high"
                  preloadImg
                  />
              </div>
            </div>
          }
        </div>
      </div>
    }

<ng-template #videoCtaButton let-modifier>
  <button type="button" class="home-hero__video-cta {{ modifier }}" (click)="playVideo($event)">
    <span class="home-hero__video-cta-icon" aria-hidden="true">
      <svg width="14" height="14" viewBox="0 0 24 24" focusable="false">
        <polygon points="5,3 21,12 5,21" fill="#ffffff" />
      </svg>
    </span>
    <span class="home-hero__video-cta-label">{{ videoCta.ctaLabel }}</span>
  </button>
</ng-template>
